<p>message-set-detail-card works!</p>
